import { getGaCookieValue } from 'analytics/utils/getGaCookieValue/getGaCookieValue'
import type { Session } from 'session/src/types/session'
import type { MessagePullingResponse } from '../types/AIResponseTypes'

interface ChatbotMessagePullingOptions {
	countryISO: string
	sessionId: string | null
	token: Session['token']
	languageISO: string
	timeZone: string
}

export const chatbotMessagePulling = async (
	url: URL,
	{
		countryISO,
		timeZone,
		sessionId,
		token,
		languageISO,
	}: ChatbotMessagePullingOptions
): Promise<MessagePullingResponse> => {
	return (
		await fetch(url.href, {
			next: { revalidate: 0 },
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				queryInput: {
					text: '',
					languageCode: languageISO,
				},
				queryParams: {
					timeZone,
					sessionID: sessionId,
					payload: { source: 'chat' },
					customParams: {
						languageCode: languageISO,
						countryCode: countryISO,
						source: 'chat',
						isTesting: null,
						orders: null,
						ordersId: null,
						externalId: null,
						isConversational: true,
						isOutlet: false,
						userPseudoId: getGaCookieValue(),
						gaSessionId: window.analytics.sessionId,
					},
				},
			}),
		})
	).json()
}
